module.exports = __webpack_public_path__ + "static/media/chatterbox.cbac5657.jpg";